import React from 'react';
import TransitionLink from './TransitionLink';
import { useLanguage } from '../context/LanguageContext';
import { useTranslation } from '../translations/translations';

const PathwaysSection = () => {
    const { language } = useLanguage();
    const t = useTranslation(language);

    const pathways = [
        { to: '/landing-broadcast', title: t('pathwayBroadcastTitle'), body: t('pathwayBroadcastBody') },
        { to: '/landing-dev', title: t('pathwayDevTitle'), body: t('pathwayDevBody') },
        { to: '/landing-trainer', title: t('pathwayTrainerTitle'), body: t('pathwayTrainerBody') },
    ];

    return (
        <section className="w-full bg-white py-24 px-8 md:px-16 rounded-t-[40px] rounded-b-[40px]">
            <div className="max-w-6xl mx-auto">
                <h2 className="text-sm font-mono text-gray-400 tracking-widest uppercase mb-10">
                    {t('pathwaysTitle')}
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    {pathways.map((item) => (
                        <TransitionLink
                            key={item.to}
                            to={item.to}
                            className="group block border border-black/10 rounded-2xl p-8 hover:border-orange-400/50 transition-colors duration-300"
                        >
                            <h3 className="text-xl font-black text-black mb-3 tracking-tight group-hover:text-orange-500 transition-colors duration-300">
                                {item.title}
                            </h3>
                            <p className="text-gray-600 leading-relaxed text-sm mb-6">
                                {item.body}
                            </p>
                            <span className="text-sm text-gray-400 font-mono group-hover:text-orange-500 transition-colors duration-300 inline-flex items-center">
                                {t('pathwayCta')}
                                <span className="ml-2 group-hover:translate-x-1 transition-transform duration-300">→</span>
                            </span>
                        </TransitionLink>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default PathwaysSection;
